import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 產品詳情。
 * `GET /crm/product/{id}` — Ver4 detail envelope。
 *
 * @param {string} id
 */
export async function fetchProductDetail(id) {
  const { data: raw } = await request.get(`/crm/product/${id}`);
  return parseVer4DetailResponse(raw);
}
